import React from 'react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { removeStep } from '../../../state';

interface DeleteStepButtonProps {
  index: number;
}

export const DeleteStepButton: React.FC<DeleteStepButtonProps> = ({ index }) => {
  const dispatch = useAppDispatch();
  const stepsCount = useAppSelector((state) => state.workflow.currentWorkflow?.steps.length ?? 0);

  return (
    <IconButton
      size="small"
      onClick={() => dispatch(removeStep(index))}
      sx={{ color: '#ef4444' }}
      disabled={stepsCount === 1}
    >
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
};

export default DeleteStepButton;
